/**
 * @param obj
 * @returns boolean
 */
export const checkObjectIsEmpty = (obj) => Object.entries(obj).length === 0
  && obj.constructor === Object;

/**
 * @param template
 * @param params
 * @returns string
 */
export const nativeTemplate = (template, params) => {
  if (!template || !params
    || template === ''
    || checkObjectIsEmpty(params)) return undefined;
  let result = template;
  // eslint-disable-next-line
  Object.keys(params).forEach((x) => { result = result.replace('${' + x + '}', params[x]); });
  return result;
};

export default {
  nativeTemplate,
  checkObjectIsEmpty,
};
